import React, { useEffect, useMemo, useRef, useState } from "react";
import { Row, Col, Spin, Modal, message, Form, Select, Breadcrumb, Button } from "antd";
import AtomButton from "atoms/Button";
import styled from "@emotion/styled";
import { connect, useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import {
	getUserRoleId,
	getSelectedDepartmentId,
	getStatusListFromID,
	getClientid,
	getAllDepartmentList,
	getLocations,
	getMenuList,
	getallRoleList,
	getUserList,
} from "redux/selectors";
import { setAllRoleList, setRoleList, setUserList, setUserRole } from "redux/actions";
import COLORS from "common/Colors";
import { CALL_API } from "common/API";
import { STATUS_CODE } from "common/Constants";
import { CSVLink } from "react-csv";
import EditRole from "organisms/EditRole";
import PermissionsRole from "organisms/EditRoleNew";
import NewRolesAndPermissions from "pages/NewRolesAndPermissions";

import { reduce, get } from "lodash";
import Table from "atoms/Table";
import { ButtonOutlined } from "reusableComponent/UIButtons";
import { DropdownCheckBox } from "atoms/UIDropdown/Dropdown";
import queryKeys from "common/queryKey";
import { useScrollFetch } from "hooks/useScrollFetch";
import { useFetch } from "hooks/useFetch";
import { EyeOutlined, EditOutlined } from "@ant-design/icons";
const { Option } = Select;

const StyledTable = styled(Table)`
.clickable-row {
  cursor: pointer;
}
  /* padding-top: 20px; */
  table {
    table-layout: auto !important;
  }
  .permissions-cell {
    visibility: hidden; /* reserve space but hide */
    opacity: 0; /* fully transparent */
    transition: opacity 0.2s ease-in-out;
  }

  .ant-table-row:hover .permissions-cell {
    visibility: visible; /* show on hover */
    opacity: 1; /* fade in smoothly */
  }
  .ant-table-content {
    overflow-x: auto;
  }
  .ant-table-cell {
    padding: 10px;
    height: 0px !important;
    border: none;
  }

  .ant-table-thead
    > tr
    > th:not(:last-child):not(.ant-table-selection-column):not(
      .ant-table-row-expand-icon-cell
    ):not([colspan])::before {
    background: none;
  }

  .ant-table-thead .ant-table-cell {
    font-weight: bold;
    color: ${COLORS.SECONDARY_BLACK};
  }
  .ant-table-tbody > tr > td {
    border-bottom: 1px solid #f0f0f0 !important;
  }
  .non-white {
    background: #f9f9f9;
  }
`;

const StyleddeactivateModal = styled(Modal)`
  .ant-modal-header {
    border-bottom: none;
    padding: 35px 0px 20px 0px;
  }
  .ant-modal-content {
    box-shadow: 0px 0px 8px #00000029;
    border-radius: 5px;
  }
  .ant-modal-title {
    text-align: center;
    font-size: 16px;
  }
  .ant-modal-body {
    padding: 0px 0px 35px 0px;
  }
  .ant-modal-close-x {
    display: none;
  }
  .page-title-head {
    justify-content: center;
  }
  .ant-modal-footer {
    display: none;
  }
`;

const StyledButton = styled(AtomButton)`
  width: 125px;
  color: white;
  background-color: #00685F;
  border-radius: 5px;
  margin-left: 5%;
  color: #ffffff !important;
  &:hover {   background-color: #00685F;
  border-color: #00685F;
  color: #ffffff !important;
  
  }

`;
const StyledButtonCancel = styled(AtomButton)`
  width: 125px;
  color: white;
  background-color: #ffffff;
  border-radius: 5px;
  margin-left: 5%;
  border-color: #000000;
  color: #000000 !important;
  &:hover {   background-color: #ffffff;
  border-color: #000000;
  color: #000000 !important;
  }

`;

const StyledPermissionButton = styled(AtomButton)`
  background-color: #deefee !important;
  border: none !important;
  border-radius: 6px !important;
  color: #00685F !important;
  font-weight: 500;
  display: inline-flex !important;
  align-items: center;
  justify-content: center;

  &:hover {
      background-color: #deefee !important;
  color: #00685F !important;

  }
`;

const SaveButton = styled(Button)`
  background: #00685f!important;
  border-color: #00685f !important;
  color: #deefee !important;

  &:hover,
  &:focus,
  &:active {
   background: #00685f!important;
  border-color: #00685f !important;
  color: #deefee !important;
  }
`;

const Cancelbutton = styled(Button)`
  background: #ffffff !important;
  border-color: #000000 !important;
  color: #000000 !important;

  &:hover,
  &:focus,
  &:active {
	background: #ffffff !important;
  border-color: #000000 !important;
  color: #000000 !important;
  }
`;

const PRIMARY = "#2ecc71";
const PRIMARY_LIGHT = "#c2fae5";

const StyledAddRoleButton = styled(Button)`
  width: 150px;
  color: #fff !important;
  background-color: #00685F;
  border-color: #00685F;
  border-radius: 5px;
  &:hover,
  &:focus,
  &:active,
  &.active {
    background-color: #00685F !important;
    border-color: #00685F !important;
    color: #fff !important;
  }
`;

const PageWrap = styled.div`
  background: #fff;
  min-height: 100vh;
  font-size: 15px;

  .ant-breadcrumb-link {
    font-weight: 500 !important;
  }
  .breadcrumb-wrap {
    padding: 4px 6px 0;
    font-size: 16px;
  }

  .ant-form-item-label > label {
    font-size: 15px !important;
    font-weight: 500 !important;
  }
  .ant-input {
    font-size: 14px !important;
  }

  .stepper-wrap {
    display: flex;
    justify-content: center;
    padding: 28px 0 40px;
    margin-bottom: 50px;
  }

  .step-row {
    display: flex;
    align-items: flex-start;
  }

  .step-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    position: relative;
    z-index: 1;
  }

  .step-circle {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    border: 2px solid #d0d0d0;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    font-weight: 600;
    color: #aaa;
    background: #fff;
    transition: all 0.3s;
    position: relative;
    z-index: 2;
  }
  .step-circle.active {
    border-color: #000;
    color: #363636;
    background: #d9fcf0;
  }
  .step-circle.done {
    color: #313131;
    background: #d9fcf0;
    border-color: ${PRIMARY};
  }

  .step-label {
    font-size: 14px;
    color: #aaa;
    font-weight: 500;
    white-space: nowrap;
  }
  .step-label.active {
    color: #a09c9c;
    font-size: 16px;
    font-weight: 500;
  }
  .step-label.done {
    color: #a09c9c;
    font-size: 16px;
    font-weight: 500;
  }

  .step-line {
    width: 120px;
    height: 2px;
    background: #d0d0d0;
    flex-shrink: 0;
    margin-left: -34px;
    margin-right: -34px;
    margin-top: 29px;
    z-index: 0;
    position: relative;
  }
  .step-line.done {
    background: ${PRIMARY};
  }

  .form-footer {
    position: fixed;
    bottom: 0;
    background: #fff;
    border-top: 1px solid #eee;
    padding: 12px 24px;
    display: flex;
    justify-content: flex-end;
    gap: 0px;
    z-index: 100;
    font-size: 16px !important;
  }

  .btn-cancel {
    border-radius: 4px !important;
    border: 1px solid #1a1a1a !important;
    color: #1a1a1a !important;
    font-weight: 500 !important;
    height: 35px !important;
    padding: 0 20px !important;
    font-size: 16px !important;
  }
  .btn-primary {
    border-radius: 4px !important;
    background: ${PRIMARY_LIGHT} !important;
    border-color: ${PRIMARY_LIGHT} !important;
    color: #111 !important;
    font-weight: 600 !important;
    height: 35px !important;
    padding: 0 24px !important;
    font-size: 16px !important;
  }
`;

const StyledInfoModal = styled(Modal)`
  .ant-modal-content {
    border-radius: 10px;
    padding: 24px 24px 20px;
  }

  .ant-modal-body {
    padding: 0;
  }

  .ant-modal-footer {
    display: none;
  }
`;

const roleSteps = [
	{ label: "Basic" },
	{ label: "Permission" },
];

const CreateRolePage = ({ form, onCancel, onFinish, menuList, setMenuList, createLoading, existingRoleNames }) => {
	const [currentStep, setCurrentStep] = useState(0);
	const [roleName, setRoleName] = useState("");
	const pageWrapRef = useRef(null);
	const [footerRect, setFooterRect] = useState({ left: 0, width: "100%" });

	useEffect(() => {
		const node = pageWrapRef.current;
		if (!node) return;
		const updateFooterRect = () => {
			const rect = node.getBoundingClientRect();
			setFooterRect({ left: rect.left, width: rect.width });
		};
		updateFooterRect();
		const observer = new ResizeObserver(updateFooterRect);
		observer.observe(node);
		window.addEventListener("resize", updateFooterRect);
		return () => {
			observer.disconnect();
			window.removeEventListener("resize", updateFooterRect);
		};
	}, []);

	const duplicateNameValidator = (_, value) => {
		if (!value || !value.trim()) return Promise.resolve();
		const trimmed = value.trim().toLowerCase();
		if ((existingRoleNames || []).map((n) => n.toLowerCase()).includes(trimmed)) {
			return Promise.reject(new Error("A role with this name already exists"));
		}
		return Promise.resolve();
	};

	const handleNext = async () => {
		try {
			const values = await form.validateFields(["roleName"]);
			setRoleName(values.roleName);
			setCurrentStep(1);
		} catch {
			// validation shows inline error
		}
	};

	const handleCreate = (updatedMenuList) => {
		onFinish({ roleName }, updatedMenuList);
	};

	return (
		<PageWrap ref={pageWrapRef}>
			<div className="breadcrumb-wrap">
				<Breadcrumb>
					<Breadcrumb.Item
						onClick={onCancel}
						style={{ cursor: "pointer", color: "#8c98aa" }}
					>
						Role
					</Breadcrumb.Item>
					<Breadcrumb.Item>Add Role</Breadcrumb.Item>
				</Breadcrumb>
			</div>

			<div className="stepper-wrap">
				<div className="step-row">
					{roleSteps.map((step, index) => (
						<React.Fragment key={index}>
							<div className="step-item">
								<div
									className={`step-circle ${index < currentStep
										? "done"
										: index === currentStep
											? "active"
											: ""
										}`}
								>
									{index < currentStep ? "✓" : index + 1}
								</div>
								<div
									className={`step-label ${index < currentStep
										? "done"
										: index === currentStep
											? "active"
											: ""
										}`}
								>
									{step.label}
								</div>
							</div>
							{index < roleSteps.length - 1 && (
								<div
									className={`step-line ${index < currentStep ? "done" : ""}`}
								/>
							)}
						</React.Fragment>
					))}
				</div>
			</div>

			{currentStep === 0 && (
				<>
					<div style={{ padding: "0 24px" }}>
						<Form form={form} layout="vertical">
							<Form.Item
								name="roleName"
								label="Role"
								rules={[
									{ required: true, message: "Role name is required" },
									{ validator: duplicateNameValidator },
								]}
							>
								<input
									className="ant-input"
									placeholder="Role Name"
									style={{
										width: "100%",
										padding: "8px 12px",
										border: "1px solid #d9d9d9",
										borderRadius: 4,
										fontSize: 14,
										outline: "none",
									}}
								/>
							</Form.Item>
						</Form>
					</div>
					<div className="form-footer" style={{ left: footerRect.left, width: footerRect.width }}>
						<StyledButtonCancel onClick={onCancel}>
							Cancel
						</StyledButtonCancel>
						<StyledButton onClick={handleNext}>
							Next
						</StyledButton>
					</div>
				</>
			)}

			{currentStep === 1 && (
				<div style={{ padding: "0 24px" }}>
					<NewRolesAndPermissions
						menuList={menuList}
						setMenuList={setMenuList}
						viewOnly={false}
						type="add"
						step={currentStep}
						setStep={setCurrentStep}
						onFinish={handleCreate}
						loading={createLoading}
						handleCancel={onCancel}
					/>
				</div>
			)}
		</PageWrap>
	);
};

function Roles({
	clientId,
	AllDepartmentList,
	locationList,
	menuList,
	userRoleId,
	saveAllRoleList,
	allRoleList,
}) {
	const [addRole, toggleAddRole] = useState(false);
	const [editRole, toggleEditRole] = useState(false);
	const [RoleDetails, setRoleDetails] = useState({});
	const [roleList, setRoleLists] = useState(allRoleList);
	const [deleteRole, setDeleteRole] = useState(false);
	const [roleid, setRoleid] = useState("");
	const [displayLocationLoader, setDisplayLocationLoader] = useState(false);
	const [roleCSVlist, setroleCSVlist] = useState([]);
	const [btnLoader, togglebtnLoader] = useState(false);
	const [pageLoading, setPageLoading] = useState(false);
	const [isModalVisible, setIsModalVisible] = useState(false);
	const [selectedRole, setSelectedRole] = useState(null);
	const [permissionMode, setPermissionMode] = useState(false);
	const [permissionForEdit, setPermissionForEdit] = useState(false);
	const [newRoleMenuList, setNewRoleMenuList] = useState(() => {
		const template = menuList[userRoleId] || Object.values(menuList)[0] || [];
		return template.map((item) => ({
			...item,
			access: false,
			permission: { view: false, create: false, edit: false, delete: false },
			subMenu: (item.subMenu || []).map((sub) => ({
				...sub,
				access: false,
				permission: { view: false, create: false, edit: false, delete: false },
			})),
		}));
	});
	const [createLoading, setCreateLoading] = useState(false);
	const [editNameVisible, setEditNameVisible] = useState(false);
	const [editNameRecord, setEditNameRecord] = useState(null);
	const [editNameValue, setEditNameValue] = useState("");
	const [editNameLoading, setEditNameLoading] = useState(false);
	const [roleAssignedModal, setRoleAssignedModal] = useState(false);
	const [roleAssignedMessage, setRoleAssignedMessage] = useState("");

	const [addRoleForm] = Form.useForm();
	const dispatch = useDispatch();

	const Menulist = menuList[userRoleId] || Object.values(menuList)[0];
	const userList = useSelector(getUserList);
	const userInfo = useSelector((store) => get(store, "common.userInfo"));

	const csvLinkEl = useRef();

	const CSVHeaders = [
		{ label: "Role name", key: "roleName" },
		{ label: "Department", key: "department" },
		{ label: "Country", key: "country" },
		{ label: "Location", key: "locationId" },
		{ label: "Created On", key: "insertedAt" },
	];

	const showModal = (role, mode) => {
		setSelectedRole(role);
		setPermissionMode(mode);
		setIsModalVisible(true);
		setPermissionForEdit(true)
	};

	const handleOk = () => {
		setIsModalVisible(false);
	};

	const handleCancel = () => {
		setIsModalVisible(false);
	};

	const columns = [
		{
			title: "Role Name",
			dataIndex: "roleName",
			key: "role_name",
			width: "10%",
			sorter: (a, b) => a.roleName.localeCompare(b.roleName),
		},
		{
			title: "No of Employees in",
			dataIndex: "roleId",
			key: "roleId",
			width: "20%",
			className: "normal-column",
			render: (roleId) => {
				return userList?.filter((val) => {
					const roles = Array.isArray(val?.roleid)
						? val.roleid
						: val?.roleid
							? [val.roleid]
							: [];
					return (
						roles.includes(roleId) &&
						val.statusid === "1" &&
						val.usertype === "Employee"
					);
				})?.length;
			},
		},
		{
			title: "Employees with custom permissions",
			dataIndex: "customPermissionIds",
			key: "customPermissionIds",
			width: "20%",
			className: "normal-column",
			render: (customPermissionIds) => {
				return Array.isArray(customPermissionIds)
					? customPermissionIds.length
					: 0;
			},
		},
		{
			title: "",
			key: "actions",
			width: "10%",
			align: "center",
			render: (_, record) => (
				<div
					className="permissions-cell"
					style={{
						display: "flex",
						alignItems: "center",
						justifyContent: "center",
						gap: "8px",
						whiteSpace: "nowrap",
					}}
				>
					{(userInfo?.roleId === "2" || Menulist?.find(
						(item) =>
							item?.key === "manage" &&
							item?.subMenu?.find(
								(subItem) =>
									subItem?.key === "roles" && subItem?.permission?.edit
							)
					)) && (
							<StyledPermissionButton
								icon={<EditOutlined />}
								style={{
									color: "#00685F",
									cursor: "pointer",
									background: "#deefee",
									padding: "2px",
									borderRadius: "4px",
									height: "25px",
									width: "25px",
									fontSize: 18
								}}
								onClick={(e) => {
									e.stopPropagation();
									setEditNameRecord(record);
									setEditNameValue(record.roleName);   // pre-populate
									setEditNameVisible(true);
								}}
							/>
						)}
					{(userInfo?.roleId === "2" || Menulist?.find(
						(item) =>
							item?.key === "manage" &&
							item?.subMenu?.find(
								(subItem) =>
									subItem?.key === "roles" && subItem?.permission?.delete
							)
					)) && (
							<StyledPermissionButton
								onClick={(e) => {
									e.stopPropagation();
									setRoleid(record.roleId);
									setDeleteRole(true);
								}}
							>
								Delete
							</StyledPermissionButton>
						)}
					<StyledPermissionButton
						icon={<EyeOutlined />}
						onClick={(e) => {
							e.stopPropagation();
							showModal(record, true);
						}}
					>
						Permissions
					</StyledPermissionButton>
				</div>
			),
		},
	];

	const [form] = Form.useForm();

	useEffect(() => {
		refetch();
	}, []);

	useEffect(() => {
		refetch();
	}, [setRoleLists]);

	useEffect(() => {
		setRoleLists(allRoleList);
	}, [allRoleList]);

	const getFilteredRoleList = () => {
		const department = form.getFieldValue("department");
		const country = form.getFieldValue("country");
		const name = form.getFieldValue("roleName");

		let baseList = dataList?.filter((role) => role.display === 1) || [];

		if (!department && !country && !name) {
			return baseList;
		} else {
			return name?.length > 0
				? permissonByName
					?.filter((role) => role.display === 1) // ✅ apply filter here also
					.filter((role) => {
						const departmentMatch =
							department && department.length > 0
								? department.some((d) => role.department.includes(d))
								: true;

						const countryMatch =
							country && country.length > 0
								? country.some((c) => role.locationId.includes(c))
								: true;

						return departmentMatch && countryMatch;
					})
				: baseList.filter((role) => {
					const departmentMatch =
						department && department.length > 0
							? department.some((d) => role.department.includes(d))
							: true;

					const countryMatch =
						country && country.length > 0
							? country.some((c) => role.locationId.includes(c))
							: true;

					return departmentMatch && countryMatch;
				});
		}
	};

	const { getRolesList, getPermissonNameList, getPermissionByName } = queryKeys;

	const { key, url } = getRolesList(clientId);

	const { data, lastElementRef, isLoading, refetch, isReloading } =
		useScrollFetch(key, {
			endPoint: url,
			queryParam: "lastEvaluatedKey",
			onFetchStart: () => setPageLoading(true),
			onFetchEnd: () => setPageLoading(false),
		});

	const dataList = useMemo(() => {
		if (data) {
			return data?.pages?.reduce((acc, page) => {
				if (page?.data === undefined) return acc;
				return [...acc, ...page?.data];
			}, []);
		} else {
			return [];
		}
	}, [data]);

	const { key: permissonKey, url: permissionUrlByname } = getPermissionByName(
		clientId,
		form.getFieldValue("roleName")
	);

	const {
		data: permissionData,
		lastElementRef: permissionRef,
		isLoading: permissionLoaded,
	} = useScrollFetch(permissonKey, {
		endPoint: permissionUrlByname,
		queryParam: "lastEvaluatedKey",
	});

	const permissonByName = useMemo(() => {
		if (permissionData) {
			return permissionData.pages.reduce((acc, page) => {
				if (page?.response?.data === undefined) return acc;
				const responseData = page.response.data;
				if (Array.isArray(responseData)) {
					return [...acc, ...responseData];
				} else if (typeof responseData === "object") {
					return [...acc, responseData];
				}
				return acc;
			}, []);
		} else {
			return [];
		}
	}, [permissionData]);

	const { key: permissionNameKey, url: permissionUrl } =
		getPermissonNameList(clientId);

	const { data: permissionNameList } = useFetch(
		permissionNameKey,
		permissionUrl,
		{
			enabled: true,
		},
		{
			clientId: clientId,
		}
	);

	const permissionList = permissionNameList?.response?.data;

	useEffect(() => {
		saveAllRoleList(dataList);
	}, [dataList]);

	const prepareCSV = async () => {
		togglebtnLoader(true);
		if (getFilteredRoleList().length > 0) {
			setroleCSVlist(
				reduce(
					getFilteredRoleList(),
					function (result, list) {
						const departmentIds = Array.isArray(list?.department)
							? list?.department
							: [list?.department];
						const departmentNames = departmentIds.map((id) => {
							const matchingDepartment = AllDepartmentList.find(
								(item) => item.department_id === id
							);
							return matchingDepartment
								? matchingDepartment.department_name
								: "";
						});

						const locationIdIds = Array.isArray(list?.locationId)
							? list?.locationId
							: [list?.locationId];
						const locationNames = locationIdIds.map((id) => {
							const matchinglocationId = locationList.find(
								(item) => item.location_id === id
							);
							return matchinglocationId ? matchinglocationId.location_name : "";
						});
						const countryNames = locationIdIds.map((id) => {
							const matchinglocationId = locationList.find(
								(item) => item.location_id === id
							);
							return matchinglocationId ? matchinglocationId.country : "";
						});

						result.push({
							Name: list.roleName,
							Department: departmentNames?.join(", "),
							Country: countryNames?.join(", "),
							Location: locationNames?.join(", "),
						});
						return result;
					},
					[]
				)
			);
			setTimeout(() => {
				csvLinkEl.current.link.click();
			});
		} else {
			message.error(`No data available to download.`);
		}
		togglebtnLoader(false);
	};

	const getBlankMenuList = () => {
		const template = menuList[userRoleId] || Object.values(menuList)[0] || [];
		return template.map((item) => ({
			...item,
			access: false,
			permission: { view: false, create: false, edit: false, delete: false },
			subMenu: (item.subMenu || []).map((sub) => ({
				...sub,
				access: false,
				permission: { view: false, create: false, edit: false, delete: false },
			})),
		}));
	};

	const deletedRole = () => {
		setDeleteRole(true);
	};

	const ViewRole = (RoleObject, isViewOnly = false) => {
		setRoleid(RoleObject.roleId);
		toggleEditRole(true);
		setRoleDetails({
			...RoleObject,
			isViewOnly,
		});
	};

	const refetchAndSyncRedux = async () => {
		const token = window.localStorage.getItem("token");
		const { jwtDecode } = await import("jwt-decode");
		const clientId = jwtDecode(token)?.clientId;
		const { roleList, userList } = await CALL_API(
			`master-data/${clientId}`,
			"post", { fetch_master_data: true, }
		);
		dispatch(setRoleList(roleList || []));
		dispatch(setUserList(userList || []));
	};

	const confirmdelete = async () => {
		setDisplayLocationLoader(true);
		togglebtnLoader(true);
		try {
			const response = await CALL_API(
				`owner-roles/${clientId}/${roleid}`,
				"delete",
				{ statusid: "0" }
			);
			console.log("Delete response:", response);
			if (response?.code === "SUCCESS") {
				// role deleted successfully
				if (
					response?.message ===
					"Role Already Assigned to User. So you can't able to delete"
					|| response?.message.includes("Role Already Assigned to User. So you can't able to delete")
				) {
					setDeleteRole(false);
					setRoleAssignedMessage(
						"You cannot delete this role because employees are still assigned to it. Please reassign them to another role before proceeding."
					);
					setRoleAssignedModal(true);
				} else {
					setDeleteRole(false);
					message.success(response?.message || "Role deleted successfully");
					toggleEditRole(false);
					await refetchAndSyncRedux();
					refetch();
				}
			} else {
				message.error(response?.message || "Failed to delete role");
			}
		} catch (err) {
			message.error("Failed to delete role");
		} finally {
			setDisplayLocationLoader(false);
			togglebtnLoader(false);
		}
	};

	const headerstyle = { fontSize: "20px", fontWeight: "bold" };

	const handleAddRole = async (values, menuList) => {
		try {
			setCreateLoading(true);
			const response = await CALL_API(`owner-roles/${clientId}`, "post", {
				roleName: values.roleName,
				menuList: menuList || [],
			});
			if (response?.code === STATUS_CODE.SUCCESS) {
				message.success("Role created successfully");
				toggleAddRole(false);
				addRoleForm.resetFields();
				setNewRoleMenuList(getBlankMenuList());
				refetch();
			} else {
				const errMsg = response?.response?.message || response?.message;
				message.error(errMsg || "Failed to create role");
			}
		} catch (error) {
			const errMsg = error?.response?.data?.response?.message || error?.response?.data?.message || error?.message;
			message.error(errMsg || "Failed to create role");
		} finally {
			setCreateLoading(false);
		}
	};

	const handleUpdateRoleName = async () => {
		const trimmed = editNameValue.trim();
		if (!trimmed) return;
	
		// Skip check if name is unchanged
		if (trimmed.toLowerCase() !== editNameRecord?.roleName?.trim().toLowerCase()) {
		const isDuplicate = (dataList || []).some(
			(r) => r.roleName?.trim().toLowerCase() === trimmed.toLowerCase()
		);
		if (isDuplicate) {
			message.error("A role with this name already exists");
			return;
		}
		}
	
		setEditNameLoading(true);
		try {
			const response = await CALL_API(
				`owner-roles/${clientId}/${editNameRecord.roleId}`,
				"patch",
				{ roleName: trimmed }
			);
			if (response?.code === "SUCCESS") {
				await refetchAndSyncRedux();
				message.success("Role name updated successfully");
				setEditNameVisible(false);
				refetch();
			}
		} catch {
			message.error("Failed to update role name");
		} finally {
			setEditNameLoading(false);
		}
	};

	return (
		<>
			{!addRole && !editRole && (
				<Row className="page-title">
					<Col sm={24} md={12} style={headerstyle}>
						Role - Permission
					</Col>
					<Col
						sm={24}
						md={12}
						className="d-flex justify-content-end algin-items-center"
					>
						<StyledAddRoleButton onClick={() => { addRoleForm.resetFields(); toggleAddRole(true); }}>
							Add Role
						</StyledAddRoleButton>
					</Col>
				</Row>
			)}
			<div className="mt-3 mb-3">
				{!addRole && !editRole && <h6>Total Role : {getFilteredRoleList()?.length || 0}</h6>}
			</div>

			{!addRole && !editRole && (
				<Spin
					spinning={pageLoading || isLoading || permissionLoaded || isReloading}
				>
					<StyledTable
						className="mb-5"
						dataSource={getFilteredRoleList()}
						columns={columns}
						rowKey="role_id"
						pagination={false}
						showLoader={isLoading}
						onRow={(record, index) => ({
							ref: index === dataList?.length - 1 ? lastElementRef : null,
							onClick: () => {
								ViewRole(record);
							},
						})}
						rowClassName={() => "clickable-row"}
						footer={
							!isLoading
								? () => (
									<>
										{isReloading && !isLoading && (
											<div style={{ textAlign: "center" }}>
												<Spin spinning={isReloading} />
											</div>
										)}
									</>
								)
								: false
						}
					/>
				</Spin>
			)}
			<Modal
				title={`${selectedRole?.roleName || ""} Permission`}
				open={isModalVisible}
				footer={null}
				onCancel={handleCancel}
				width="90%"
				style={{ top: 10, padding: 0, bottom: 10, borderRadius: 16, }}
				bodyStyle={{
					height: "85vh",
					overflowY: "auto",
					padding: "20px 40px",
				}}
				centered
				maskClosable={false}
				destroyOnClose
			>
				{selectedRole && (
					<PermissionsRole
						isModalVisible={true}
						closeModal={handleCancel}
						getRoleList={refetch}
						RoleDetails={selectedRole}
						deleteRole={deletedRole}
						setPageLoading={setPageLoading}
						viewOnly={permissionMode}
						permissionForEdit={permissionForEdit}
					/>
				)}
			</Modal>

			<Modal
				title="Edit Role Name"
				open={editNameVisible}
				onCancel={() => setEditNameVisible(false)}
				centered
				width={380}
				maskClosable={false}
				destroyOnClose
				footer={
					<div style={{ display: "flex", justifyContent: "flex-end", gap: 10 }}>
						<Cancelbutton onClick={() => setEditNameVisible(false)}>Cancel</Cancelbutton>
						<SaveButton
							loading={editNameLoading}
							style={{ background: "#00685F", borderColor: "#00685F" }}
							onClick={handleUpdateRoleName}
						>
							Update
						</SaveButton>
					</div>
				}
			>
				<Form layout="vertical" style={{ marginTop: 8 }}>
					<Form.Item
						label="Role Name"
						required
						validateStatus={
							!editNameValue.trim() ? "error"
							: (dataList || []).some(
								(r) => r.roleName?.trim().toLowerCase() === editNameValue.trim().toLowerCase()
								&& r.roleId !== editNameRecord?.roleId
							) ? "error" : ""
						}
						help={
							!editNameValue.trim() ? "Role name is required"
							: (dataList || []).some(
								(r) => r.roleName?.trim().toLowerCase() === editNameValue.trim().toLowerCase()
								&& r.roleId !== editNameRecord?.roleId
							) ? "A role with this name already exists" : undefined
						}
					>
						<input
							className="ant-input"
							value={editNameValue}
							onChange={(e) => setEditNameValue(e.target.value)}
							onKeyDown={(e) => e.key === "Enter" && handleUpdateRoleName()}
							placeholder="Role Name"
							style={{ width:"100%", padding:"7px 11px", border:"1px solid #d9d9d9", borderRadius:4, fontSize:14 }}
						/>
					</Form.Item>
				</Form>
			</Modal>

			{addRole && (
				<CreateRolePage
					form={addRoleForm}
					onCancel={() => { toggleAddRole(false); addRoleForm.resetFields(); setNewRoleMenuList(getBlankMenuList()); }}
					onFinish={handleAddRole}
					menuList={newRoleMenuList}
					setMenuList={setNewRoleMenuList}
					createLoading={createLoading}
					existingRoleNames={dataList?.map((r) => r.roleName) ?? []}
				/>
			)}

			{editRole && (
				<EditRole
					isModalVisible={editRole}
					closeModal={() => {
						toggleEditRole(false);
						form.resetFields();
					}}
					toggleEditRole={toggleEditRole}
					getRoleList={refetch}
					RoleDetails={RoleDetails}
					deleteRole={deletedRole}
					setPageLoading={setPageLoading}
					viewOnly={
						Menulist?.find(
							(item) =>
								item?.key === "manage" &&
								item?.subMenu.find(
									(subItem) =>
										subItem?.key === "roles" && subItem?.permission.edit
								)
						)
							? false
							: true
					}
				/>
			)}

			<StyleddeactivateModal
				title="Are you sure you want to Delete this Role?"
				width={500}
				open={deleteRole}
				onCancel={() => setDeleteRole(false)}
				footer={[]}
				centered
			>
				<Row className="page-title-head">
					<Col>
						<StyledButtonCancel
							className="mx-2"
							// type="primary"
							htmlType="submit"
							onClick={() => setDeleteRole(false)}
						>
							No
						</StyledButtonCancel>
					</Col>
					<Col>
						<StyledButton
							className="mx-2"
							loading={btnLoader}
							// type="primary"
							htmlType="submit"
							onClick={confirmdelete}
						>
							{btnLoader ? "Yes" : "Yes"}
						</StyledButton>
					</Col>
				</Row>
			</StyleddeactivateModal>

			<StyledInfoModal
				open={roleAssignedModal}
				onCancel={() => setRoleAssignedModal(false)}
				centered
				width={470}
				maskClosable={false}
				closeIcon={null}
				footer={null}
			>
				<div
					style={{
						display: "flex",
						flexDirection: "column",
						alignItems: "center",
						textAlign: "center",
						paddingTop: 10,
					}}
				>
					<div
						style={{
							width: 34,
							height: 34,
							borderRadius: "50%",
							background: "#ff3b30",
							display: "flex",
							alignItems: "center",
							justifyContent: "center",
							color: "#fff",
							fontSize: 22,
							fontWeight: 700,
							marginBottom: 24,
						}}
					>
						!
					</div>

					<div
						style={{
							fontSize: 16,
							lineHeight: "28px",
							color: "#5b5b5b",
							maxWidth: 360,
							marginBottom: 28,
							fontWeight: 400,
						}}
					>
						{roleAssignedMessage}
					</div>

					<Button
						onClick={() => setRoleAssignedModal(false)}
						style={{
							minWidth: 130,
							height: 40,
							borderRadius: 8,
							border: "1px solid #315efb",
							color: "#315efb",
							fontWeight: 500,
							fontSize: 16,
						}}
					>
						Got it
					</Button>
				</div>
			</StyledInfoModal>
		</>
	);
}

const mapStateToProps = (state) => ({
	userRoleId: getUserRoleId(state),
	statusListFromID: getStatusListFromID(state, [4, 5, 6]),
	selectedDepartmentId: getSelectedDepartmentId(state),
	clientId: getClientid(state),
	AllDepartmentList: getAllDepartmentList(state),
	locationList: getLocations(state),
	menuList: getMenuList(state),
	allRoleList: getallRoleList(state),
});
const mapDispatchToProps = (dispatch) =>
	bindActionCreators(
		{
			saveRoleList: setRoleList,
			saveAllRoleList: setAllRoleList,
		},
		dispatch
	);

export default connect(mapStateToProps, mapDispatchToProps, null)(Roles);